export type PublicationBookingModel = {
  artwork_counts?: {
    approved: number,
    required: number,
  },
  available_space: number,
  booking_confirmation_id?: number,
  booking_confirmed: boolean,
  booking_error?: string,
  brand_group_id?: number,
  cache_key: number,
  dates: any
  deleted: boolean,
  ftp_transfer_data?: any,
  ftp_transfer_successful: boolean,
  id: number,
  layout_template_id: number,
  notes?: string,
  page_options?: [],
  page_position?: number | string,
  preflight_notes?: number,
  preflight_status_id?: number,
  preflighted_by_id?: number,
  publication_booking_item_ids?: number[],
  publication_edition_id: number,
  publication_id: number,
  publication_order_id?: number,
  publication_product_id?: number,
  sort?: number,
  status_id?: number,
  user_id?: number,
}

export type PublicationBookingRequestOptions = {
  include_publication_booking_artwork_count?: boolean,
  include_publication_booking_brand_group?: boolean,
  include_publication_booking_item_campaign?: boolean,
  include_publication_booking_items?: boolean,
  include_publication_booking_preflighted_by?: boolean,
  include_publication_booking_publication?: boolean,
  include_publication_booking_publication_edition?: boolean,
  include_publication_booking_publication_order?: boolean,
  include_publication_booking_publication_product?: boolean,
  include_publication_edition_deadlines?: boolean,
}

const state = {
  booking_confirmation_id: '',
  layout_template_id: undefined,
  notes: '',
  page_options: [],
  page_position: '',
  preflight_notes: '',
  preflight_status_id: undefined,
  publication_edition_id: undefined,
  publication_id: undefined,
  publication_product_id: undefined,
}

export const requiredFields = [
  { key: 'layout_template_id' },
  { key: 'publication_edition_id' },
  { key: 'publication_id' },
  { key: 'publication_product_id' },
]

export default state
